import React from 'react';
import { Route, Routes, Navigate } from "react-router-dom";
import VideoChat from '../components/VideoChat';
import Register from '../components/Register';
import Login from '../components/Login';
import ProductAuthAdd from '../components/Pages/ProductAuthAdd';
import AddServiceAuth from '../components/Pages/AddServiceAuth';
import UserProfile from '../components/Pages/UserProfile';
import Dashboard from '../components/Pages/Dashboard';
import Meetings from '../components/Pages/Meetings';
import MeetingForm from '../components/Pages/MeetingForm';
import PersonalDetailsForm from '../components/Pages/PersonalDetailsForm';
import CommunityChat from '../components/Pages/CommunityChat';
import MeetingRoom from '../components/Pages/MeetingRoom';
import MeetingLayout from '../components/Pages/MeetingLayout';

function UserRoute() {


  

  return (
    <Routes>
      <Route path='/' element={<CommunityChat />} />
      <Route path='/login' element={<Login/>} />
      <Route path='/register' element={<Register/>} />
      <Route path='/add-personal-detail' element={<PersonalDetailsForm />} />
      <Route path='/add-product' element={<ProductAuthAdd />} />
      <Route path='/add-service' element={<AddServiceAuth />} />
      <Route path='/profile' element={<UserProfile />} />
      <Route path='/dashboard' element={<Dashboard />} />
      <Route path='/meetings' element={<Meetings />} />
      <Route path='/add-meetings' element={<MeetingForm />} />
      <Route path='/chat-community' element={<CommunityChat />} />
      <Route path='/video-chat' element={<VideoChat />} />
      <Route path="/meeting/:roomName" element={<MeetingLayout />} />
      <Route path='*' element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default UserRoute;
